import Vue from 'vue'
import '@/assets/css/reset.scss'
import '@/assets/css/sprite.scss'
import App from './App.vue'
import router from '@/router'
import store from '@/store/'
import toast from '@/plugins/toast/'
import * as filter from '@/filters/'
import VueLazyload from 'vue-lazyload'
import client from '@/client/modules/common'
import VueCompositionApi from '@vue/composition-api'

import { appInjector } from './app-injector'
import { EventBusService } from '@/services/event-bus.service'
import { initEasyCounter } from '@crab/veekd'
import { service } from './utils/easycounter'

// 引入eruda移动端调试工具
import eruda from 'eruda'

initEasyCounter({
  http: service,
})

Vue.use(VueCompositionApi)
Vue.use(toast, {})
Vue.use(VueLazyload)

Vue.config.productionTip = false
// 全局注册
Object.keys(filter).forEach(key => {
  Vue.filter(key, (filter as any)[key])
})
Vue.prototype.$EventBus = appInjector.get(EventBusService)

if (process.env.VUE_APP_STAGE === 'test') {
  /* eslint-disable no-new */
  // const VConsole = require('vconsole/dist/vconsole.min.js')
  // new VConsole()
  eruda.init()
}

const requireComponent = require.context(
  './components/ui',
  true,
  /[a-z0-9]+\.(jsx?|vue)$/i
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName =
    componentConfig.default.name ||
    fileName.substr(fileName.lastIndexOf('/') + 1).replace(/\.\w+$/, '')

  Vue.component(componentName, componentConfig.default || componentConfig)
})

// 渠道包的tid1,tid2,tod1,tod2，传给下单接口支付统计用
async function getTid () {
  try {
    Vue.prototype.$TidObj = {}
    /* eslint-disable-next-line */
    const tid = await checkClientMethod('getTid') && await client.API.client_getTid() || {}
    /* eslint-disable-next-line */
    const sfid = await checkClientMethod('getScenesInfo') && await client.API.client_getScenesInfo() || {}
    Vue.prototype.$TidObj = { ...tid, ...sfid }
    vueInit()
  } catch (e) {
    console.log(e)
    vueInit()
  }
}

function vueInit () {
  (window as any).app = new Vue({
    router,
    store,
    mounted: () => {
      document.dispatchEvent(new Event('render-event'))
    },
    render: h => h(App)
  }).$mount('#app')
}

/**
 * 检查当前客户端是否支持该方法
 * @param {string} fname | 方法名
 */
async function checkClientMethod (fname:string) {
  const hasMethod = await client.API.client_checkMethod(fname)
  return hasMethod && hasMethod.result
}

getTid()
